import React, { Fragment } from 'react';
import { TableCell } from '../TableCell';
import TextBubble from '../../../../_lib/components/TextBubble/TextBubble';
import { Icons } from '../../../atoms/SVG';
import { ExtendedInfoSVG } from '../../../../_lib/components/ExtendedInfo';
import { TooltipPlacement } from '../../../atoms/Tooltip';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

type TableCellRole = {
  label: string;
  url?: string;
  roles: { name: string; note?: string; automaticallyAssigned?: boolean }[];
  cellProperties?: TableCell;
};
export function TableCellRole({ label, cellProperties, roles }: TableCellRole) {
  const { t } = useSonTranslation('MemberRow');

  return (
    <TableCell {...cellProperties} dataHead={label}>
      {roles && roles.length > 0 && (
        <ul className="tables__member-roles-list">
          {roles.map(role => (
            <Fragment key={role.name}>
              <li className="tables__member-roles-list-item">
                <span className="tables__member-roles-name">{role.name}</span>
                {role.automaticallyAssigned && (
                  <span className="tables__member-roles-automatic-icon">
                    <ExtendedInfoSVG
                      helpText={t('roles.automaticallyAssigned')}
                      tooltipPlacement={TooltipPlacement.TOP}
                      svgSpriteID={Icons.AUTOMATIC}
                    />
                  </span>
                )}
              </li>
              {role.note && <TextBubble modifier="margin-bottom" key={role.note} type="note" content={role.note} />}
            </Fragment>
          ))}
        </ul>
      )}
    </TableCell>
  );
}
